import { DateTime } from 'luxon';
import { createArtificialId } from '../../common/utils';
import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import { PlanillaPartidoOfflineAssertions } from '../../system/PlanillaPartidoOffline/PlanillaPartidoOfflineAssertions';
import { PlanillaPartidoOficial } from '../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';
import { PlanillaPartidoOficialMesaNoRegsitrado } from '../../system/PlanillaPartidoOficialMesaNoRegsitrado/PlanillaPartidoOficialMesaNoRegsitrado';
import ArbitroOfflineForm from './ArbitroOfflineForm';
import PartidoOfflineForm from './PartidoOfflineForm';
import OficialDeMesaOfflineForm from './OficialDeMesaOfflineForm';
import { Jugador } from '../../system/Jugador/Jugador';
import JugadorOfflineForm from './JugadorOfflineForm';
import OficialOfflineForm from './OficialOfflineForm';
import OficialAuxiliarOfflineForm from './OficialAuxiliarOfflineForm';
import ArbitroSecundarioOfflineForm from './ArbitroSecundarioOfflineForm';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';

class PlanillaPartidoOfflineForm extends CustomForm {
  private partido: PartidoOfflineForm;
  private arbitro1: ArbitroOfflineForm;
  private arbitro2: ArbitroSecundarioOfflineForm;
  private oficialDeMesaLocal: OficialDeMesaOfflineForm;
  private oficialDeMesaVisitante: OficialDeMesaOfflineForm;
  private jugadorAAgregar: JugadorOfflineForm;
  private oficialAAgregar: OficialOfflineForm;
  private oficialAuxiliarAAgregar: OficialAuxiliarOfflineForm;

  protected constructor(
    ppo_id: string | null,
    ppo_equipo_local_id: number,
    ppo_equipo_visitante_id: number,
    ppo_parid: number,
    ppo_arbid_1: number,
    ppo_arbid_2: number,
    ppo_fecha_hora_inicio: Date,
    ppo_cjid: number | null,
    // ppo_ofmid_local: number,
    // ppo_ofmid_visitante: number,
    ppo_goles_local: number,
    ppo_goles_visitante: number,
    ppo_diferido: any,
    ppo_observacion: any,
    ppo_informe: any,
    ppo_estado: string,
    ppo_usid_carga: number,
    ppo_fecha_carga: Date,
    ppo_suspendida: boolean,
    campo_de_juego: string,

    planilla_partido_jugador: PlanillaPartidoJugador[],
    oficiales: PlanillaPartidoOficial[],
    oficiales_auxiliares: PlanillaPartidoOficialAuxiliar[],
    oficiales_mesa_no_registrados: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    const ppoff = PlanillaPartidoOfflineAssertions.build();
    super('PlanillaPartidoOffline', ppoff);
    this.addInputAsserted('ppo_id', ppo_id);
    this.addInputAsserted('ppo_equipo_local_id', ppo_equipo_local_id);
    this.addInputAsserted('ppo_equipo_visitante_id', ppo_equipo_visitante_id);
    this.addInputAsserted('ppo_parid', ppo_parid);
    this.addInputAsserted('ppo_arbid_1', ppo_arbid_1);
    this.addInputAsserted('ppo_arbid_2', ppo_arbid_2);
    this.addInputAsserted('ppo_fecha_hora_inicio', ppo_fecha_hora_inicio);
    this.addInputAsserted('ppo_cjid', ppo_cjid);

    // this.addInput('ppo_ofmid_local', ppo_ofmid_local);
    // this.addInput('ppo_ofmid_visitante', ppo_ofmid_visitante);
    this.oficialDeMesaLocal = OficialDeMesaOfflineForm.initialize();
    this.addFormInput(this.oficialDeMesaLocal);

    this.oficialDeMesaVisitante = OficialDeMesaOfflineForm.initialize();
    this.addFormInput(this.oficialDeMesaVisitante);

    this.addInputAsserted('ppo_goles_local', ppo_goles_local);
    this.addInputAsserted('ppo_goles_visitante', ppo_goles_visitante);
    this.addInputAsserted('ppo_diferido', ppo_diferido);
    this.addInputAsserted('ppo_observacion', ppo_observacion);
    this.addInput('ppo_informe', ppo_informe); // PONER INPUT ASSERTED
    this.addInputAsserted('ppo_estado', ppo_estado);
    this.addInputAsserted('ppo_usid_carga', ppo_usid_carga);
    this.addInputAsserted('ppo_fecha_carga', ppo_fecha_carga);
    this.addInputAsserted('ppo_suspendida', ppo_suspendida);

    this.partido = PartidoOfflineForm.initialize();
    this.addFormInput(this.partido);

    this.arbitro1 = ArbitroOfflineForm.initialize();
    this.addFormInput(this.arbitro1);

    this.arbitro2 = ArbitroSecundarioOfflineForm.initialize();
    this.addFormInput(this.arbitro2);

    this.addInput('campo_de_juego', campo_de_juego);
    this.addInputAsserted('planilla_partido_jugador', planilla_partido_jugador);
    this.addInputAsserted('oficiales', oficiales);
    this.addInputAsserted('oficiales_auxiliares', oficiales_auxiliares);
    this.addInputAsserted('oficiales_mesa_no_registrados', oficiales_mesa_no_registrados);

    this.jugadorAAgregar = JugadorOfflineForm.initialize();
    this.oficialAAgregar = OficialOfflineForm.initialize();
    this.oficialAuxiliarAAgregar = OficialAuxiliarOfflineForm.initialize();
  }

  private static build(
    ppo_id: string | null,
    ppo_equipo_local_id: number,
    ppo_equipo_visitante_id: number,
    ppo_parid: number,
    ppo_arbid_1: number,
    ppo_arbid_2: number,
    ppo_fecha_hora_inicio: Date,
    ppo_cjid: number | null,
    ppo_goles_local: number,
    ppo_goles_visitante: number,
    ppo_diferido: any,
    ppo_observacion: any,
    ppo_informe: any,
    ppo_estado: string,
    ppo_usid_carga: number,
    ppo_fecha_carga: Date,
    ppo_suspendida: boolean,
    campo_de_juego: string,
    planilla_partido_jugador: PlanillaPartidoJugador[],
    oficiales: PlanillaPartidoOficial[],
    oficiales_auxiliares: PlanillaPartidoOficialAuxiliar[],
    oficiales_mesa_no_registrados: PlanillaPartidoOficialMesaNoRegsitrado[]
  ) {
    return new this(
      ppo_id,
      ppo_equipo_local_id,
      ppo_equipo_visitante_id,
      ppo_parid,
      ppo_arbid_1,
      ppo_arbid_2,
      ppo_fecha_hora_inicio,
      ppo_cjid,
      ppo_goles_local,
      ppo_goles_visitante,
      ppo_diferido,
      ppo_observacion,
      ppo_informe,
      ppo_estado,
      ppo_usid_carga,
      ppo_fecha_carga,
      ppo_suspendida,
      campo_de_juego,
      planilla_partido_jugador,
      oficiales,
      oficiales_auxiliares,
      oficiales_mesa_no_registrados
    );
  }

  static initialize() {
    return this.build(
      '1',
      createArtificialId(),
      createArtificialId(),
      createArtificialId(),
      0,
      0,
      new Date(),
      0,
      // 0,
      // 0,
      0,
      0,
      false,
      null,
      null,
      '',
      0,
      new Date(),
      false,
      '',
      // [],
      [],
      [],
      [],
      []
    );
  }

  toPlanillaPartido(): PlanillaPartido {
    return PlanillaPartido.createFrom(
      this.getIdInput().getValue(),
      this.getParidInput().getValue(),
      0,
      0,
      this.getFechaHoraInicioInput().getValue(),
      0,
      this.getOficialDeMesaLocalForm().getIdInput().getValue(),
      this.getOficialDeMesaVisitanteForm().getIdInput().getValue(),
      0,
      0,
      this.getDiferidoInput().getValue(),
      '',
      '',
      '',
      0,
      new Date(),
      false,
      this.getSuspendidaInput().getValue(),
      '',
      this.getPartidoForm().getTorneoForm().getEmpInput().getValue(),
      this.getPartidoForm().toPartido(
        this.getEquipoLocalIdInput().getValue(),
        this.getEquipoVisitanteIdInput().getValue()
      ),
      this.getArbitro1Form().toArbitro(),
      this.getArbitro2Form().toArbitro(),
      this.getPlanillaPartidoJugadoresInput().getValue(),
      this.getOficialesInput().getValue(),
      this.getOficialesAuxiliaresInput().getValue(),
      this.getOficialesMesaNoRegistradosInput().getValue()
    );
  }

  getHorario() {
    const date = this.getFechaHoraInicioInput().getValue() as Date;
    return DateTime.fromJSDate(date).toFormat('HH:mm');
  }

  getIdInput() {
    return this.getInputByName('ppo_id');
  }

  getEquipoLocalIdInput() {
    return this.getInputByName('ppo_equipo_local_id');
  }

  getEquipoVisitanteIdInput() {
    return this.getInputByName('ppo_equipo_visitante_id');
  }

  getParidInput() {
    return this.getInputByName('ppo_parid');
  }

  getSuspendidaInput() {
    return this.getInputByName('ppo_suspendida');
  }

  getArbid1Input() {
    return this.getInputByName('ppo_arbid_1');
  }

  getArbid2Input() {
    return this.getInputByName('ppo_arbid_2');
  }

  getFechaHoraInicioInput() {
    return this.getInputByName('ppo_fecha_hora_inicio');
  }

  getCjidInput() {
    return this.getInputByName('ppo_cjid');
  }

  getOficialDeMesaLocalForm() {
    return this.oficialDeMesaLocal;
  }

  getOficialDeMesaVisitanteForm() {
    return this.oficialDeMesaVisitante;
  }

  getGolesLocalInput() {
    return this.getInputByName('ppo_goles_local');
  }

  getGolesVisitanteInput() {
    return this.getInputByName('ppo_goles_visitante');
  }

  getDiferidoInput() {
    return this.getInputByName('ppo_diferido');
  }

  getObservacionInput() {
    return this.getInputByName('ppo_observacion');
  }

  getInformeInput() {
    return this.getInputByName('ppo_informe');
  }

  getEstadoInput() {
    return this.getInputByName('ppo_estado');
  }

  getUsidCargaInput() {
    return this.getInputByName('ppo_usid_carga');
  }

  getFechaCargaInput() {
    return this.getInputByName('ppo_fecha_carga');
  }

  getPartidoForm() {
    return this.partido;
  }

  getArbitro1Form() {
    return this.arbitro1;
  }

  getArbitro2Form() {
    return this.arbitro2;
  }

  getCampoDeJuegoInput() {
    return this.getInputByName('campo_de_juego');
  }

  getPlanillaPartidoJugadoresInput() {
    return this.getInputByName('planilla_partido_jugador');
  }

  getOficialesInput() {
    return this.getInputByName('oficiales');
  }

  getOficialesAuxiliaresInput() {
    return this.getInputByName('oficiales_auxiliares');
  }

  getOficialesMesaNoRegistradosInput() {
    return this.getInputByName('oficiales_mesa_no_registrados');
  }

  getJugadorAAgregarForm() {
    return this.jugadorAAgregar;
  }

  getOficialAAgregarForm() {
    return this.oficialAAgregar;
  }

  getOficialAuxiliarAAgregarForm() {
    return this.oficialAuxiliarAAgregar;
  }

  reinitializeJugadorAAgregarForm() {
    this.jugadorAAgregar = JugadorOfflineForm.initialize();
  }

  reinitializeOficialAAgregarForm() {
    this.oficialAAgregar = OficialOfflineForm.initialize();
  }

  reinitializeOficialAuxiliarAAgregarForm() {
    this.oficialAuxiliarAAgregar = OficialAuxiliarOfflineForm.initialize();
  }

  getListPlanillaPartidoJugadoresByEquipo(equipoId: string) {
    const planillaPartidoJugador =
      this.getPlanillaPartidoJugadoresInput().getValue() as PlanillaPartidoJugador[];

    return planillaPartidoJugador
      .filter((ppj) => +ppj.getEqid()! === +equipoId && ppj.isActive())
      .sort((a, b) => Jugador.sortByFullameFn(a.getJugador(), b.getJugador()));
  }

  getJugadoresByEquipo(equipoId: string) {
    return this.getListPlanillaPartidoJugadoresByEquipo(equipoId).map((ppj) => ppj.getJugador());
  }

  getDorsalBy(jugId: string) {
    const planillaPartidoJugador =
      this.getPlanillaPartidoJugadoresInput().getValue() as PlanillaPartidoJugador[];
    const jug = planillaPartidoJugador.find((ppj) => +ppj.getJugid() === +jugId && ppj.isActive());
    return jug?.getDorsal() ? String(jug?.getDorsal()) : '';
  }

  getOficialesAuxiliaresByEquipoId(equipoId: string) {
    const ret = this.getOficialesAuxiliaresInput()
      .getValue()
      .filter((oa: PlanillaPartidoOficialAuxiliar) => oa.isActive() && +oa.getEqid() === +equipoId)
      .map((oa: PlanillaPartidoOficialAuxiliar) => oa.toJSON());
    return ret;
  }
}

export default PlanillaPartidoOfflineForm;
